import {
  FieldTypes,
  IField,
} from "@/api/AppApi/services/builder/interfaces/interfaces";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import OneOption from "./OneOption";
import InputErrorMsg from "../../form-builder-helpers/InputErrorMsg";
import RequiredStar from "@/app/components/lib/RequiredStar";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
}

const HookRadioButtons: React.FC<Props> = ({ form, field }) => {
  const t = useTranslation();
  const fConfig = field.configurations;
  const selectedKey = form.watch(fConfig.key);
  const onChange = (key: string) => {
    if (fConfig.type === FieldTypes.radio_buttons)
      return selectedKey === key ? null : key;
    const currentSelected: string[] = [...selectedKey];
    selectedKey.includes(key)
      ? currentSelected.splice(selectedKey.indexOf(key), 1)
      : currentSelected.push(key);
    return currentSelected;
  };
  const is_multi_select = fConfig.type === FieldTypes.checkbox;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      {!fConfig.hideLabel && (
        <RequiredStar title={fConfig.title} isRequired={fConfig.is_required} />
      )}
      {field.data.map((item) => (
        <Controller
          key={item.key}
          name={fConfig.key}
          control={form.control}
          rules={{
            validate: (value) =>
              fConfig.is_required && !value ? t.this_field_is_required : true,
          }}
          render={({ field }) => (
            <OneOption
              label={item.value}
              is_multi_select={is_multi_select}
              checked={
                is_multi_select
                  ? selectedKey?.includes(item.key)
                  : selectedKey === item.key
              }
              toggleOption={() => field.onChange(onChange(item.key))}
            />
          )}
        />
      ))}
      {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
      <InputErrorMsg
        errorMsg={form.formState.errors[fConfig.key]?.message as string}
      />
    </div>
  );
};

export default HookRadioButtons;
